module.exports = __webpack_public_path__ + "static/media/RepiCzGrey.d546d7b1.svg";